import { createStyles } from '@mui/styles';

// Types
import { APTheme } from '../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
	"@keyframes onloadup": {
		"0%": {
			opacity: 0,
			transform: "translateY(65px)"
		},
		"100%": {
			opacity: 1,
			transform: "translateY(0)"
		}
	},
	accountContainer: {
		background: '#F5F5F5',
		color: '#4a4a4a',
		fontSize: 16,
		letterSpacing: '-0.5px',
		height: '100%',
		padding: '34px 35px',
		animationName: `$onloadup`,
		animationDuration: '0.3s',
		animationFillMode: 'both',
		animationTimingFunction: 'cubic-bezier(0.680, -0.550, 0.265, 1.550) both',
		'@media(max-width: 1200px)': {
			paddingLeft: 110,
		},
		'@media(max-width: 768px)': {
			padding: 30,
		},
		'@media(max-width: 480px)': {
			padding: 20,
		}
	},
	accountContainerContent: {
		maxWidth: '1110px',
		position: 'relative',
		height: '100%'
	},
	accountChart: {
		background: '#FFF',
		margin: '20px 0',
		padding: 20
	},
	accountSectionSummary: {
		padding: '15px 1.875em',
		'@media(max-width: 1200px)': {
			padding: '1.25em',
		}
	},
	accountSection: {
		padding: 30,
		'@media(max-width: 480px)': {
			padding: 20,
		}
	},
	accountTable: {
		background: '#FFF'
	},
	downloadButtons: {},
	dropDownMenu: {
		position: 'absolute',
		top: -55,
		right: 0
	},
	statistics: {
		display: 'flex',
		justifyContent: 'space-between',
		'@media(max-width: 990px)': {
			display: 'block',
		}
	},
	ssoBannerContainer: {
		display: 'flex',
		padding: 15,
		alignItems: 'center',
		alignSelf: 'stretch',
		background: '#F5F5F5',
		boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.08)',
		fontSize: 16,
		width: '-webkit-fill-available',
		marginBottom: 15,
		'& svg': {
			width: '20px',
			height: '20px',
			verticalAlign: 'middle',
			flexShrink: 0
		}
	},
	snackBarWidth: {
		width: '-moz-available'
	},
	ssoSwitchAccountIconContainer: {
		marginRight: 15,
		display: 'flex',
		width: 35,
		height: 35,
		justifyContent: 'center',
		alignItems: 'center',
		gap: 9.333,
		borderRadius: '100%',
		background: '#2D91E9',
		flexShrink: 0
	},
	svgSSOSwitchAccountIcon: {
		width: 23.33,
		height: 23.33,
		flexShrink: 0
	},
	svgIconClose: {
		cursor: 'pointer',
		pointerEvents: 'all',
		marginLeft: 'auto'
	}
});
